const accordion = {

	init() {
		document.querySelectorAll('.accordion .br-toggle').forEach( function( element ) {
			element.toggle = Object.assign(new BRToggle(element, { accordion: false }));
		});		
	}
	
};

export { accordion };
